import './buy.css';
import { useEffect, useState } from 'react';
import { useLang } from '../../context/LangContext';
import { useServer } from '../../context/serverContext';
import { endpoints } from '../../env';
import { useBuy } from '../../context/BuyContext';
import { useNavigate,Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

const Buy = ({idCourse, isMember}) => {
    const { isAuth } = useAuth();
    const { lang } = useLang();
    const { postRequest, getRequest }= useServer();
    const { setToken, setInfoSell, setProduct } = useBuy();
    const [courseSell, setCourseSell] = useState(null);
    const [buyEnable, setBuyEnable]= useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        postRequest(endpoints.getCourseSell + idCourse +'/get', {},(res) =>{
            if(res[0]){
                setCourseSell(res[1].sell);
                setInfoSell(res[1].sell);
                setProduct()
            }else{
                console.log("Fail");
            }
        });
       
        getRequest(endpoints.getCourse, {course_id: idCourse}, (res) => {
            if (res[0]) {
                res = res[1];
                setProduct(res.course);   
            }
        });

    }, []);



   
    const buy = () => {
        if(isAuth){
            postRequest(endpoints.createPayIntent, {course_sell_id: courseSell.id },(res) =>{
                if(res[0]){
                    setToken(res[1].checkout.token);
                    navigate('/payment');
                }else{
                    console.log("Fail");
                }
            });

        }else{
          setBuyEnable(true);
        }
        
     };

    return (
        <div>
            {courseSell && courseSell.enable === 1 && !isMember && (
           
             <div>
                {courseSell.is_sale === 0 ? (
                    <span className='price-regular'>${courseSell.price}</span>
                ) : (
                    <div className='div-sale-price'>
                        <span className='sale-price-regular'>${courseSell.price}</span>
                        <span className='sale-price'>${courseSell.sale_price}</span>
                    </div>
                )}
             <div >
                 { lang === "en" ? (<><p className='btn-buy-course' onClick={buy}> Buy </p>
                 {buyEnable && <p><Link to={'/login'}>Login</Link> to buy this course</p>}
                 </>

                 ) : (<><p className='btn-buy-course' onClick={buy}> Comprar </p>
                 {buyEnable && <p><Link to={'/login'}>Inicia sesión</Link> para comprar este curso</p>}</>
                 )}
             </div>
             
             
         </div>
        )}

   

        </div>
    );
}

export default Buy;
